/* eslint-disable */
import * as Yup from 'yup';
import { oc } from 'ts-optchain';

function equalTo(ref: any, msg: string) {
  // @ts-ignore
  return this.test({
    name: 'equalTo',
    exclusive: false,
    message: msg || '${path} must be the same as ${reference}',
    params: {
      reference: ref.path
    },
    test(value: any) {
      return value === this.resolve(ref);
    }
  });
}

Yup.addMethod(Yup.string, 'equalTo', equalTo);

function greaterThan(path: string, msg: string, opts?: { inclusive: boolean }) {
  const inclusive = oc(opts).inclusive(false);
  const reference = Yup.ref(path);

  let defaultMsg;

  if (inclusive) {
    defaultMsg = '${reference} must be greater than or equal to ${path}';
  } else {
    defaultMsg = '${reference} must be greater than to ${path}';
  }

  // @ts-ignore
  return this.test({
    name: 'greaterThan',
    exclusive: false,
    message: msg || defaultMsg,
    params: { reference },
    test(value: string) {
      const prev = parseInt(value, 10) || 0;
      const next = parseInt(this.resolve(reference), 10) || 0;

      return inclusive ? prev >= next : prev > next;
    }
  });
}

Yup.addMethod(Yup.string, 'greaterThan', greaterThan);

function lessThan(path: string, msg: string, opts?: { inclusive: boolean }) {
  const inclusive = oc(opts).inclusive(false);
  const reference = Yup.ref(path);

  let defaultMsg;

  if (inclusive) {
    defaultMsg = '${reference} must be less than or equal to ${path}';
  } else {
    defaultMsg = '${reference} must be less than to ${path}';
  }

  // @ts-ignore
  return this.test({
    name: 'lessThan',
    exclusive: false,
    message: msg || defaultMsg,
    params: { reference },
    test(value: string) {
      const prev = parseInt(value, 10) || 0;
      const next = parseInt(this.resolve(reference), 10) || 0;

      return inclusive ? prev <= next : prev < next;
    }
  });
}

Yup.addMethod(Yup.string, 'lessThan', lessThan);

function lessThanValue(path: string, msg: string, opts?: { inclusive: boolean }) {
  const inclusive = oc(opts).inclusive(false);
  const reference = path;

  let defaultMsg;

  if (inclusive) {
    defaultMsg = '${reference} must be less than or equal to ${path}';
  } else {
    defaultMsg = '${reference} must be less than to ${path}';
  }

  // @ts-ignore
  return this.test({
    name: 'lessThanValue',
    exclusive: false,
    message: msg || defaultMsg,
    params: { reference },
    test(value: string) {
      const prev = value || 0;
      const ref = reference || 0;
      if (ref) {
        return inclusive ? prev <= ref : prev < ref;
      }
      return true;
    }
  });
}

Yup.addMethod(Yup.string, 'lessThanValue', lessThanValue);

function whiteSpace(msg: string) {
  let defaultMsg = '${reference} must be less than to ${path}';

  // @ts-ignore
  return this.test({
    name: 'whiteSpace',
    exclusive: false,
    message: msg || defaultMsg,
    test(value: string) {
      return value && value.trim().length;
    }
  });
}

Yup.addMethod(Yup.string, 'whiteSpace', whiteSpace);
